import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { Layout } from '../AuthLayout/styles';

export const NonAuthLayout = (props: { children: React.ReactNode }) => {
  const location = useLocation();
  const capitalizeFirstLetter = (string: string) => {
    return string.charAt(1).toUpperCase() + string.slice(2);
  };

  useEffect(() => {
    let currentPage = capitalizeFirstLetter(location.pathname);
    currentPage = currentPage.replace(/-/g, ' ');
    document.title = `${currentPage} | Carsparency | Inspection Application`;
  });

  return (
    <React.Fragment>
      <Layout>{props.children}</Layout>
    </React.Fragment>
  );
};
